import { ApplyOnlineOptionsConst } from "@/src/constants/apply-online";
import ArrowSelectSvg from "@/src/svg/applyOnline/ArrowSelectSvg";
import { IFormApplicationProps } from "@/src/types/applyOnline";
import { FC } from "react";

const FormApplicationProgram: FC<IFormApplicationProps & { handleFocus?: () => void }> = ({ register, control, errors, handleFocus }) => {
  return (
    <div className="form-application-additional-info">
      <div className="form-application-header">
        <h1 className="form-application-header-title">Program Details</h1>
      </div>
      <div className="form-application-body">
        <div className="form-application-body-select speciality">
          <select className="form-application-body-input select" defaultValue="" onFocus={handleFocus} {...register("speciality")}>
            {ApplyOnlineOptionsConst.speciality.map(({ value, label, disabled }) => (
              <option key={value} value={value} disabled={disabled}>
                {label}
              </option>
            ))}
          </select>
          <ArrowSelectSvg />
        </div>

        <div className="form-application-body-select levelEducation">
          <select className="form-application-body-input select" defaultValue="" onFocus={handleFocus} {...register("levelEducation")}>
            {ApplyOnlineOptionsConst.levelEducation.map(({ value, label, disabled }) => (
              <option key={value} value={value} disabled={disabled}>
                {label}
              </option>
            ))}
          </select>
          <ArrowSelectSvg />
        </div>
        <div className="form-application-body-select formStudy">
          <select className="form-application-body-input select" defaultValue="" onFocus={handleFocus} {...register("formStudy")}>
            {ApplyOnlineOptionsConst.formStudy.map(({ value, label, disabled }) => (
              <option key={value} value={value} disabled={disabled}>
                {label}
              </option>
            ))}
          </select>
          <ArrowSelectSvg />
        </div>

        <textarea
          className="form-application-body-input comment"
          placeholder="Cover Letter"
          onFocus={handleFocus}
          {...register("comment")}
        />
      </div>
    </div>
  );
};

export default FormApplicationProgram;
